import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class BackendTranslateService {

    constructor(private translate: TranslateService) {}

    /**
     * @param {string} data - The message key in format of "msgKey{0}{1}..." that is coming from server
     * @param {string} [path=apiMessages] - The JSON key path to the level of incoming message key
     */
    public translateMessage(data: string, path?: string): string {
    	if(data) {
    		data = data.trim();
            const messagePath = path || 'apiMessages';
            const parsedElement = this.parseParams(data);
            parsedElement.parsed
                ? data = this.translate.instant(`${messagePath}.${parsedElement.message}`, parsedElement.paramsObject)
                : data = this.translate.instant(`${messagePath}.${data.replace(/{}/gi, '')}`);
            return data;
    	}
    	return '';
    }

    public translateCollection(data: Array<any>, path?: string): Array<any> {
        const messagePath = path || 'apiMessages';
        data.forEach((element, index) => {
            element = element.trim();
            const parsedElement = this.parseParams(element);
            parsedElement.parsed
                ? data[index] = this.translate.instant(`${messagePath}.${parsedElement.message}`, parsedElement.paramsObject)
                : data[index] = this.translate.instant(`${messagePath}.${element}`);
        });
        return data;
    }

    private parseParams(stringData: string) {
        stringData = stringData.replace(/{}/gi, '{empty}');

        const interpolationRegEx = /\{([^}]+)\}/g;
        const paramsObject = {};

        let newString = stringData;
        let paramCounter = 0;

        let match;
        do {
          match = interpolationRegEx.exec(stringData);
          if (match) {
            newString = newString.replace(match[0], '');
            if (match[1] === 'empty') {
               paramsObject[`p${paramCounter}`] = '';
            } else {
              paramsObject[`p${paramCounter}`] = match[1];
            }
            paramCounter++;
          }

        } while (match);

        return {
          parsed: paramCounter !== 0,
          message: newString,
          paramsObject
        };
    }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/helper/backend-translate.service.ts